import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 記録者ID
 */
export class RecorderId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): RecorderId {
    return new RecorderId(value);
  }
}
